import * as React from "react";
import {cx} from "emotion";

import "./logos-card.scss";

import {Types}     from "@Common/types";

import {formatImageSize} from "../../format-image-size";

type Logo = Types.Xpresso.Account.Common.LogoPanel.Logo;

export const LogoCard = ({
    logo,
    onEdit,
    onDelete,
}: {
    logo: Logo,
    onEdit?: () => any,
    onDelete?: () => any,
}) => ({
    render: () => (
        <div
            className="logos-card"
            key={logo.id}
            xd-qa-type="card"
            xd-qa-name={`${logo.name}.${logo.fileType}`}
        >
            <div className="logos">
                <div className="img-box">
                    <img
                        className="image"
                        src={logo.thumbnailUrl}
                        alt={logo.name + "." + logo.fileType}
                        xd-qa-name="logo"
                        xd-qa-type="image"
                    />
                </div>
            </div>
            <div className="box">
                <div className="info">
                    <div
                        className="file-name"
                        xd-qa-name="File Name"
                        xd-qa-type="label"
                        title={logo.name + "." + logo.fileType}
                    >
                        {logo.name + "." + logo.fileType}
                    </div>
                    <div
                        className="file-size"
                        xd-qa-name="File Size"
                        xd-qa-type="label"
                    >
                        {formatImageSize(logo.fileSize)}
                    </div>
                </div>
                {onEdit && <div className="edit-delete">
                    <button
                        className="edit"
                        xd-qa-type="link"
                        xd-qa-name="Edit"
                        onClick={onEdit}
                    >
                        Edit
                    </button>
                    <div className="line"/>
                    <button
                        className="delete"
                        xd-qa-type="link"
                        xd-qa-name="Delete"
                        onClick={onDelete}
                    >
                        Delete
                    </button>
                </div>}
            </div>
            <div
                className={cx("quality", {
                    high: logo.quality === "High",
                    medium: logo.quality === "Medium",
                    low: logo.quality === "Low",
                })}
                xd-qa-name="Quality"
                xd-qa-type="label"
            >
                {logo.quality}
            </div>
        </div>

    ),
});
